import { z } from "zod";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const types = ["new", "regular", "bac"];
export const AlertsOverlay = defineOverlay({
    defaults: {
        audioEnabled: true,
        demoMode: false,
        incentivesEnabled: false,
        minAmount: 1,
        minDonation: 1,
        type: "new",
        volume: 100,
    },
    details: {
        category: "alerts",
        description: "Utilize our donation alerts to enhance your Tiltify fundraising campaign by acknowledging donations to your fundraising stream.",
        features: [
            "St. Jude branded alerts",
            "Hidden Gifts that Give alerts",
            "Different alerts for different donation amounts",
            "Easy to set up",
            "No need for third party integration",
            "Set minimum donation amount to activate alert",
            "Acknowledges your donors on stream",
            "Displays when a reward is claimed",
        ],
        flags: {
            isFeatured: false,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "overlays/alerts.png",
        name: "Alerts",
        path: "/overlays/alerts",
        shortDescription: "Utilize our donation alerts to acknowledge donations on your stream.",
        slug: "alerts",
    },
    schema: BaseOverlayConfig.extend({
        audioEnabled: z
            .boolean()
            .default(() => AlertsOverlay._config.defaults.audioEnabled)
            .optional(),
        incentivesEnabled: z
            .boolean()
            .default(() => AlertsOverlay._config.defaults.incentivesEnabled)
            .optional(),
        minAmount: z
            .number()
            .int()
            .min(1)
            .default(() => AlertsOverlay._config.defaults.minAmount)
            .describe("Minimum donation amount needed to trigger an audio alert")
            .optional(),
        minDonation: z
            .number()
            .min(1)
            .default(1)
            .default(() => AlertsOverlay._config.defaults.minDonation)
            .describe("Minimum donation needed to trigger an alert")
            .optional(),
        type: z
            .enum(types)
            .default(() => AlertsOverlay._config.defaults.type)
            .optional(),
        volume: z
            .number()
            .int()
            .min(0)
            .max(100)
            .default(() => AlertsOverlay._config.defaults.volume)
            .optional(),
    }),
});
//# sourceMappingURL=alerts.js.map